<script>
    export default{
        data() {
            return{
                dados: {},
                contraste: false,
                linkacess: '/acessibilidade',
                linkmapa: '/mapa',
                rota: ''
            }
        },
        ready: function ()
        {
            var self = this;
            //json com os dados do header
			
					var urlAtual = window.location.href.split('/');
					var covid = false
					
					for(var c = 0;c < urlAtual.length; c++){
						if(urlAtual[c] == 'covid') {
							covid = true
						}
					}

					var options = {
						covid: covid
					}			
			
            $.getJSON('./server/header.php', options, function (dados)
            {
                self.dados = dados[0];
                //console.log(self.dados)
            });
        },
        watch: {
            $route () {
                this.rota = this.$route.path
                this.contraste = false
                this.contrastealter()
            },
            contraste(){
                this.contrastealter()
            }
        },
        methods: {
            irpara(item){
                $('html, body').animate({
                    scrollTop: $("#"+item)
                }, 0);                
            },
            contrastealter (){
                if(this.contraste){
                    $('header').addClass('bgpreto textobranco')
                    $('html').addClass('bgpreto')
                    $('body a').addClass('linkamarelo')
                    $('a.v-link-active').addClass('linkamarelo')
                    $('#content, #menuprincipal, .title-ouvi, .sub-title-ouvi').addClass('bgpreto textobranco')
                    $('.site-logo a span, .site-logo a h1').addClass('linkamarelo')
                    $('table>thead>tr, table>tbody>tr').addClass('bgpreto textobranco')
                    $('.portlet-title .text-success').addClass('textobranco')
                } else {
                    $('header').removeClass('bgpreto textobranco')
                    $('html').removeClass('bgpreto')
                    $('body a').removeClass('linkamarelo')
                    $('a.linkacessib.v-link-active').removeClass('linkamarelo')
                    $('#content, #menuprincipal, .title-ouvi, .sub-title-ouvi').removeClass('bgpreto textobranco')
                    $('.site-logo a span, .site-logo a h1').removeClass('linkamarelo')
                    $('table>thead>tr, table>tbody>tr').removeClass('bgpreto textobranco')
                    $('.portlet-title .text-success').removeClass('textobranco')
                }
            }
        }
    }
</script>
<template>            
    <!-- header begin -->
    <header class="site-header-3 site-header">
        <!-- Main bar start -->
        <div id="sticked-menu" class="main-bar">
            <div class="container">                
                <div class="row"> 
                            <div class="col-md-12 bar_acessibilidade acessibilidade">
                                <div id="atalhos" style="float: left;">
                                    <a style="margin-left:10px;" class="linkacessib" @click.prevent="irpara('content')" accesskey="1" >Ir para o conteúdo<span>1</span></a>
                                    <a class="linkacessib" @click.prevent="irpara('menuprincipal')" accesskey="2">Ir para o menu <span>2</span></a>
                                    <!-- <a class="linkacessib" :href="rota+'#busca-field'" accesskey="3">Ir para a busca <span>3</span></a>
                                    <a class="linkacessib" :href="rota+'#rodape'" accesskey="4">Ir para o rodapé <span>4</span></a> -->
                                </div>
                                <div id="botoes" style="float: right;">
                                    <a class="linkacessib" v-link="linkacess">Acessibilidade</a>
                                    <a class="linkacessib" href="#" id="bt_contraste" @click.prevent="contraste = !contraste">Alto Contraste</a>
                                    <a class="linkacessib" v-link="linkmapa">Mapa do Site</a>
                                </div>
                            </div>                   
                    <div class="col-md-12">
                        <!-- logo begin -->
                        <div id="logo" class="site-logo">                            
                            <a :href="dados.linklogo">
                                <img :src="dados.imglogo" alt="" class="logo logo-principal">
                                <div class="nomes-logo">
                                    <span>{{ dados.tipoentidade}}</span>
                                    <h1>{{dados.nomeentidade}}</h1>
                                </div>
                            </a>
                        </div>
                        <!-- logo close -->
                        <div class="title-system pull-right" style="">
                            <p class="title-ouvi">{{dados.nomesistema}}</p>
                            <p class="sub-title-ouvi">{{dados.subtitulosistema}}</p>
                        </div>
                        <div class="page-top page-centro">
                            <!-- BEGIN TOP NAVIGATION MENU -->
                            <div class="top-menu">
                                <!-- BEGIN RESPONSIVE MENU TOGGLER -->
                                <a href="javascript:;" class="menu-toggler responsive-toggler" data-toggle="collapse" data-target=".navbar-collapse" style="">
                                </a>
                                <!-- END RESPONSIVE MENU TOGGLER -->                                                                                            
                            </div>
                            <!-- END TOP NAVIGATION MENU -->
                        </div>                                
                    </div>
                </div>
            </div>
        </div>
    </header>
    <!-- header close -->
    <div class="gray-line"></div>
</template>
<style>
    .bar_acessibilidade{
        margin-top: 9px;
        margin-bottom: -9px;
        padding-bottom: 7px;
        border-bottom: 1px solid #f2f2f2;
    }
    
    .linkacessib{
        font-size: 12px;
        margin-right: 9px;
    }
    
    .linkacessib span {
        padding: 1px 3px;
        background-color: blue;
        color: #fff;
        font-size: 11px;
    }
    .bgpreto{
        background: #000 !important;
    }
    .textobranco{
        color: #fff !important;
    }
    .textopreto{
        color: #000 !important;
    }
    .linkamarelo{
        color: #FFF333 !important;
        background-color: #000 !important;
    }

    .page-sidebar .page-sidebar-menu .sub-menu > li:hover > a{
        background: transparent !important;
    }

    ul > li:hover > a.linkamarelo{
        background-color: #000  !important;
    }

    .bgbranco{
        background: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// header.vue?42b375e0